<style src="./SuppliersEditor.scss" lang="scss" scoped></style>
<template>
  <section class="suppliers-editor">
    <content-header path="Cadastro / Fornecedores"/>
    
    <section class="content form-box row">
      <form
        class="form-fields col-6"
        @submit.prevent="updateSupplier">
        <span class="title">Informações do fornecedor</span>
        <textbox
          class="textfield"
          v-model="form.name"
          label="Nome" />
        <textbox
          class="textfield"
          :disabled="true"
          v-model="form.alternateName"
          label="Nome alternativo" />
        <textbox
          class="textfield"
          v-model="form.contact.comercialEmail"
          label="E-Mail" />
        <phonebox
          class="textfield"
          v-model="form.contact.comercialPhone"
          label="Telefone" />
        
        <div class="textfield">
          <label class="checkbox-label">
            <span class="label">Não responde cotação</span>

            <input
              class="checkbox-input"
              type="checkbox"
              v-model="form.state.noQuote">
          </label>
        </div>

        <div class="commands">
          <button-submit
            class="submit"
            label="Atualizar Informações"
            @click="updateSupplier"
            :icon-save="commands.saveIcon"/>
        </div>
      </form>

      <section class="list-companies col-6">
        <span class="title">Empresas associadas</span>

        <div
          v-show="!form.companies || form.companies.length === 0"
          class="empty-list">
          Nehuma empresa associada
        </div>
        <ul
          v-show="form.companies"
          class="companies">
          <li
            v-for="(company, companyIdx) in form.companies"
            :key="companyIdx"
            class="company">
            <span class="name">
              {{ company.name }}
            </span>
            <span class="cnpj">
              {{ company.cnpj }}
            </span>
          </li>
        </ul>
      </section>
    </section>

  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import { Textbox, Phonebox, ButtonSubmit } from '@/components/primitives'
import { IconCheck, IconSave } from '@/components/primitives/icons'
import { LoadSupplierData, UpdateSupplier } from '@/brain/record/suppliers'

export default {
  name: 'SuppliersEditor',
  components: {
    ContentHeader,
    Textbox,
    Phonebox,
    IconCheck,
    ButtonSubmit
  },
  data () {
    return {
      form: {
        name: '',
        alternateName: '',
        contact: {
          comercialEmail: '',
          comercialPhone: ''
        },
        state: {
          noQuote: false
        },
        companies: []
      },
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  mounted () {
    this.loadSupplierData()
  },
  methods: {
    async loadSupplierData () {
      try {
        const supplierId = this.$route.params.supplierId
        const { result } = await LoadSupplierData({ supplierId })

        if (!result) {
          return
        }

        this.form.name = result.name
        this.form.alternateName = result.alternateName
        this.form.contact.comercialEmail = result.contact && result.contact.comercialEmail
        this.form.contact.comercialPhone = result.contact && result.contact.comercialPhone
        this.form.state.noQuote = result.state && result.state.noQuote
        this.form.companies = result.companies
      } catch (error) {
        this.$toasted.error('Não foi possível ler esse fornecedor')
      }
    },
    async updateSupplier () {
      try {
        this.commands.submitState = 'WAIT'
        const supplierId = this.$route.params.supplierId
        await UpdateSupplier({
          supplierId,
          ...this.form
        })
        this.$toasted.success('Fornecedor atualizado')
      } catch (error) {
        this.$toasted.error('Não foi possível atualizar esse fornecedor')
      } finally {
        this.commands.submitState = 'REPOSE'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/suppliers/suppliers-editor/SuppliersEditor.vue